import React from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectProps,
} from "@material-ui/core";

interface SelectContactTypeProps extends SelectProps {
  label: string;
  options: string[];
}

export const SelectContactType: React.FC<SelectContactTypeProps> = ({
  label,
  options,
  value,
  onChange,
  ...props
}) => {
  return (
    <FormControl
      fullWidth={props.fullWidth}
      variant="outlined"
      margin="normal"
      style={{
        minWidth: "267px",
        marginLeft: props.fullWidth ? "-15px" : "0px",
      }}
    >
      <InputLabel>{label}</InputLabel>
      <Select label={label} value={value} onChange={onChange} {...props}>
        {options.map((opt, index) => (
          <MenuItem key={index} value={opt}>
            {opt}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
